import 'owl.carousel';
import helpers from './helpers';
import modal from './modal';

global.helpers = helpers;
global.modal = modal;

function initSlider(slider) {
    
    /*
    *   This site uses Owl Carousel
    *   For documentation on events and other options please refer to their documentation
    *   https://owlcarousel2.github.io/OwlCarousel2/
    */
    
    var slider = $(slider);
    if(slider.length) { 
        slider.each(function(id) {
            var customOptions;
            var sliderParams;
            var sliderType = $(this).data('type');
            var isMobile = $(this).data('mobile-only');
            
            // Default options/params for thew slider.
            // Define custom classes to be used for the slider.
            var defaultOptions = {
                nav: true,
                dots: false,
                refreshClass: 'slider__refresh',
                loadedClass: 'slider__loaded',
                loadingClass: 'slider__loading',
                responsiveClass: 'slider__responsive',
                dragClass: 'slider__drag',
                itemClass: 'slider__item',
                stageClass: 'slider__stage',
                stageOuterClass: 'slider__stage-outer',
                grabClass: 'slider__grab',
                autoHeightClass: 'slider__height',
                navContainerClass: 'slider__nav',
                navClass: ['slider__arrow slider__prev', 'slider__arrow slider__next'],
                navText: [ '<span class="icon-arrow-left icon-18" aria-label="Previous"></span>', '<span class="icon-arrow-right icon-18" aria-label="Next"></span>' ],
                dotClass: 'slider__dot',
                dotsClass: 'slider__dots',
            }

            // Function to determine events for slider that has mobile data attr
            var sliderMobile = function(slider, params) {
                var windowSize = 990;
                
                $(document).ready(function() {
                    if ( $(window).width() < windowSize ) {
                        slider.owlCarousel(params);
                    } else {
                        slider.trigger('destroy.owl.carousel');
                    }
                });

                $(window).resize(function() {
                    if ( $(window).width() < windowSize ) {
                        slider.owlCarousel(params);
                    } else {
                        slider.trigger('destroy.owl.carousel');
                    }
                });
            };
            
            // Function to setup slide accessibility when initialized
            var sliderAccessibility = function(slider, e) {
                slider.find('.slider__item').attr('aria-selected','false');
                slider.find('.slider__item.active').attr('aria-selected','true');

                // apply meta info to next and previous buttons and make them focusable
                slider.find('.slider__prev').attr({
                    role: 'button',
                    title: 'Previous',
                    tabindex: '0',
                });
                slider.find('.slider__next').attr({
                    role: 'button',
                    title: 'Next',
                    tabindex: '0',
                }); 
            };
            
            // Custom options depending on the data-type atrtribute placed on the '.js-slider' element
            // If no attribute is defined refer to the default case
            switch (sliderType) {
                case 'multi':
                    customOptions = {
                        loop: false,
                        nav: false,
                        items:1,
                        dots: false,
                        margin: 20,
                        stagePadding: 50,
                        responsive : {
                            660 : {
                                items:2,
                                margin: 20,
                                center: false,
                            },
                            990 : {
                                items:3,
                                dots: false,
                                margin: 40,
                                nav: true,
                                stagePadding: 100,
                            },
                            1600 : {
                                items:4,
                                dots: false,
                                margin: 40,
                                nav: true,
                                stagePadding: 100,
                            }
                        }
                    }
                    break;
                default:
                    customOptions = {
                        items: 1,
                        margin:0,
                        nav: true,
                        autoHeight:true,
                        dots: false,
                        stagePadding: 0,
                        navClass: [ 'slider__btn slider__prev', 'slider__btn slider__next' ],
                    }
                    break;
            }

            //Merge the default settings with the custom settings from each slide type
            sliderParams = $.extend(true, defaultOptions, customOptions);

            // Add class based on the type of slider for any extra stying needs
            if(sliderType) {
                $(this).addClass('slider--' + sliderType);   
            } else {
                $(this).addClass('slider--default');
            }

            $(this).on('translated.owl.carousel', function(event) {                
                // Change the aria attributes after the slider has finished animation
                $(this).find('.slider__item').attr('aria-selected','false');
                $(this).find('.slider__item.active').attr('aria-selected','true');
            });
            
            // Call functions to add accessibility once the slider has initialized or changed
            $(this).on('initialized.owl.carousel', function() {
                sliderAccessibility($(this));
            });
            
            // If slider has data-mobile-only init and destroy slider based on breakpoint 
            // otherwise init slider with settings from merge
            if(isMobile !== undefined) {
                sliderMobile($(this), sliderParams);
            } else {
                $(this).owlCarousel(sliderParams);
            }
        });
        
        return $(this);
    }
}

function initMobileMenu(trigger, menu) {
    trigger = $(trigger);
    menu = $(menu);
    var backdrop = '<div class="header__backdrop"></div>';

    trigger.attr({
        'role': 'button',
        'aria-expanded': 'false'
    });

    menu.attr({
        'aria-hidden': 'true',
        'tabindex': '-1'
    });

    trigger.on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        menu.toggleClass('is-active');
        $('html, body').toggleClass('no-scroll');
    });
}


$(document).ready(function () {
    initSlider('.js-slider');
    initMobileMenu('.js-mob-menu-trigger', '.js-mob-menu');
    helpers.initReveal('.js-mobile-alert-trigger', '.js-alert-content', '', true);
});


// WEBPACK FOOTER //
// ./src/js/app.js